import gql from 'graphql-tag';

const LIQUID_M_CAMPAIGN_START = gql`
  query liquidMCampaignStart($id: Int) {
    liquidMCampaignStart(id: $id)
  }
`;

export default LIQUID_M_CAMPAIGN_START;
